import PropTypes from 'prop-types';
import React from 'react';
import styles from './BaseButtonWrapper.scss';

const BaseButtonWrapper = ({ children, className, ...rest }) => {
  return (
    <button {...rest} className={[styles['base-button-wrapper'], className || ''].join(' ')} type="button">
      {children}
    </button>
  );
};

BaseButtonWrapper.propTypes = {
  className: PropTypes.string,
};

export default BaseButtonWrapper;
